export default __webpack_public_path__ + "static/media/equity.62c1208d.jpeg";